import React, { Component } from 'react';
import { ListGroup } from 'react-bootstrap';
import ReactDatePicker from '../../../_components/DatePicker/ReactDatePicker';
import LocationOption from '../../../_components/Options/LocationOption';
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';
import moment from 'moment';
import { connect } from 'react-redux';
import FormOption from '../../../_components/Options/FormOption';

const CURRENT_STEP = 'VACCINE_DETAILS';

class VaccineDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalid: '',
      vaccine: '',
      provider: { value: '', label: '' },
      location: { value: '', label: '' },
      secondAppt: '',
      adverseDate: '',
      adverseProvider: { value: '', label: '' },
      adverseLocation: '',
      firstQuestionnaire: '',
      secondQuestionnaire: '',
      adverseQuestionnaire: '',
      manufactures: props.clientServices.VACCINE.payload,
    }
  }

  handleValidate = () => {
    const {
      vaccine,
      location,
      provider,
      secondAppt,
      adverseDate,
      adverseLocation,
      adverseProvider,
      firstQuestionnaire,
      secondQuestionnaire,
      adverseQuestionnaire
    } = this.state

    const errors = {};

    if (!location.label || !location.value) {
      errors.location = 'Please select a location.';
    }

    if (!provider.label || !provider.value) {
      errors.provider = 'Please select a provider.';
    }

    if (!adverseLocation) {
      errors.adverseLocation = 'Please select a location.';
    }

    if (!adverseProvider.label || !adverseProvider.value) {
      errors.adverseProvider = 'Please select a provider.';
    }

    if (!firstQuestionnaire) {
      errors.firstQuestionnaire = 'Please select a first questionnaire.';
    }

    if (!secondQuestionnaire && vaccine !== "janssen") {
      errors.secondQuestionnaire = 'Please select a second questionnaire.';
    }

    if (!adverseQuestionnaire) {
      errors.adverseQuestionnaire = 'Please select an adverse questionnaire.';
    }

    if (!moment(secondAppt).isValid()) {
      errors.secondAppt = 'Please enter a second appointment date.'
    } else if (moment(secondAppt).startOf('day').isBefore(moment(this.props.data.firstAppt).startOf('day'))) {
      errors.secondAppt = 'Second appointment must be after first appointment.';
    }

    if (!moment(adverseDate).isValid()) {
      errors.adverseDate = 'Please enter an adverse complete by date.'
    } else if (moment(adverseDate).startOf('day').isBefore(moment(secondAppt).startOf('day'))) {
      errors.adverseDate = 'Adverse complete by date must be after second appointment.';
    }

    this.setState({ invalid: errors });

    if (!errors.location &&
      !errors.provider &&
      !errors.secondAppt &&
      !errors.adverseDate &&
      !errors.adverseLocation &&
      !errors.adverseProvider &&
      !errors.firstQuestionnaire &&
      !errors.secondQuestionnaire &&
      !errors.adverseQuestionnaire
    ) {
      this.props.handleData({
        vaccine,
        location,
        provider,
        secondAppt,
        adverseDate,
        adverseLocation,
        adverseProvider,
        firstQuestionnaire,
        secondQuestionnaire,
        adverseQuestionnaire
      });
    }
  }

  defaultAdverseDate = (date) => {
    this.setState({ adverseDate: moment(date).add(3, 'days').toDate() })
  }

  handleSetApptDefaults = (vaccine) => {
    const { firstAppt } = this.props.data;
    const { manufactures } = this.state;

    this.setState({
      vaccine: vaccine,
      firstQuestionnaire: manufactures[vaccine].firstQuestionnaire,
      secondQuestionnaire: vaccine !== "janssen" ? manufactures[vaccine].secondQuestionnaire : '',
      adverseQuestionnaire: manufactures.adverse.questionnaire,
      adverseLocation: manufactures.adverse.location,
      adverseProvider: manufactures.adverse.provider,
    });

    if (firstAppt) {
      if (vaccine === "janssen") {
        this.setState({ secondAppt: firstAppt })
        this.defaultAdverseDate(firstAppt);
      } else {
        const secondDate = moment(firstAppt).add(manufactures[vaccine].days, 'days').toDate()
        this.setState({ secondAppt: secondDate, })
        this.defaultAdverseDate(secondDate);
      }
    }
  }

  render() {
    const {
      invalid,
      vaccine,
      provider,
      location,
      secondAppt,
      adverseDate,
      adverseProvider,
      adverseLocation,
      firstQuestionnaire,
      secondQuestionnaire,
      adverseQuestionnaire,
    } = this.state;

    const { firstAppt } = this.props.data;

    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return <div className="card axs-shadow">
      <div className="card-body">
        <h3>Mass Schedule <small>Vaccine Details</small></h3>

        <hr />

        <div className="row">
          <div className="col-12">
            <div className="alert alert-primary" role="alert">
              Add vaccination details.
            </div>

            <form className="needs-validation">
              <div className="form-row">
                <div className="form-group col-3">
                  <label>Vaccine</label>
                  <ListGroup horizontal className="text-center">
                    <ListGroup.Item
                      action
                      style={{ padding: "6px 0  6px 0" }}
                      active={vaccine === 'pfizer'}
                      onClick={e => { e.preventDefault(); this.handleSetApptDefaults('pfizer') }}>Pfizer</ListGroup.Item>
                    <ListGroup.Item
                      action
                      style={{ padding: "6px 0  6px 0" }}
                      active={vaccine === 'moderna'}
                      onClick={e => { e.preventDefault(); this.handleSetApptDefaults('moderna') }}>Moderna</ListGroup.Item>
                    <ListGroup.Item
                      action
                      style={{ padding: "6px 0  6px 0" }}
                      active={vaccine === 'janssen'}
                      onClick={e => { e.preventDefault(); this.handleSetApptDefaults('janssen') }}>Janssen</ListGroup.Item>
                  </ListGroup>
                </div>
                <div className="form-group col-3">
                  <label>Location</label>
                  <LocationOption
                    defaultValue={location.value}
                    handleSelected={(value, label) => this.setState({ location: { value: value, label: label } })} />
                  {invalid.location && <div className="text-danger"><small>{invalid.location}</small></div>}
                </div>
                <div className="form-group col-3">
                  <label>Provider</label>
                  <ProfessionalOption
                    defaultValue={provider.value}
                    handleSelected={(value, label) => this.setState({ provider: { value: value, label: label } })} />
                  {invalid.provider && <div className="text-danger"><small>{invalid.provider}</small></div>}
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col pr-1">
                  <h6>First Dose:</h6>
                </div>
                <div className={`${vaccine === "janssen" && "d-none"} col pl-1`}>
                  <h6>Second Dose:</h6>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-row">
                    <div className="form-group col">
                      <label>Appointment Date:</label> <br />
                      <ReactDatePicker
                        disabled
                        selected={firstAppt}
                        dateFormat="MMM d, yyyy"
                        className="form-control"
                        wrapperClassName="w-100"
                      />
                      {invalid.firstAppt && <div className="text-danger"><small>{invalid.firstAppt}</small></div>}
                    </div>
                    <div className="form-group col">
                      <label>Questionnaire</label>
                      <FormOption textDark defaultValue={firstQuestionnaire.value}
                        handleSelected={(value, label) =>
                          this.setState({ firstQuestionnaire: { value: value, label: label } })
                        } />
                      {invalid.firstQuestionnaire && <div className="text-danger"><small>{invalid.firstQuestionnaire}</small></div>}
                    </div>
                    <div className="col-6">
                      <div className={`${vaccine === "janssen" && "d-none"} row`}>
                        <div className="form-group col-6">
                          <label>Appointment Date:</label> <br />
                          <ReactDatePicker
                            onChange={date => {
                              this.setState({ secondAppt: date })
                              this.defaultAdverseDate(date);
                            }}
                            minDate={firstAppt || ''}
                            selected={secondAppt}
                            className={`form-control ${invalid.secondAppt ? 'is-invalid' : ''}`}
                            dateFormat="MMM d, yyyy"
                            wrapperClassName="w-100"
                          />
                          {invalid.secondAppt && <div className="text-danger"><small>{invalid.secondAppt}</small></div>}
                        </div>
                        <div className="form-group col-6">
                          <label>Questionnaire</label>
                          <FormOption
                            textDark
                            defaultValue={secondQuestionnaire.value}
                            handleSelected={(value, label) => this.setState({ secondQuestionnaire: { value: value, label: label } })} />
                          {invalid.secondQuestionnaire && <div className="text-danger"><small>{invalid.secondQuestionnaire}</small></div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <h6>Adverse:</h6>
                  <div className="form-row">
                    <div className="form-group col">
                      <label>Complete By:</label> <br />
                      <ReactDatePicker
                        minDate={secondAppt || ''}
                        selected={adverseDate}
                        onChange={date => this.setState({ adverseDate: date })}
                        dateFormat="MMM d, yyyy"
                        className={`form-control ${invalid.adverseDate ? 'is-invalid' : ''}`}
                        wrapperClassName="w-100"
                      />
                      {invalid.adverseDate && <div className="text-danger"><small>{invalid.adverseDate}</small></div>}
                    </div>
                    <div className="form-group col">
                      <label>Questionnaire</label>
                      <FormOption
                        disabled
                        textDark
                        defaultValue={adverseQuestionnaire.value}
                        handleSelected={(value, label) => this.setState({ adverseQuestionnaire: { value: value, label: label } })} />
                      {invalid.adverseQuestionnaire && <div className="text-danger"><small>{invalid.adverseQuestionnaire}</small></div>}
                    </div>
                    <div className="form-group col">
                      <label>Location</label>
                      <LocationOption
                        disabled
                        textDark
                        defaultValue={adverseLocation.value}
                        handleSelected={(value, label) => this.setState({ adverseLocation: { value: value, label: label } })} />
                      {invalid.adverseLocation && <div className="text-danger"><small>{invalid.adverseLocation}</small></div>}
                    </div>
                    <div className="form-group col">
                      <label>Provider</label>
                      <ProfessionalOption
                        defaultValue={adverseProvider.value}
                        handleSelected={(value, label) => this.setState({ adverseProvider: { value: value, label: label } })} />
                      {invalid.adverseProvider && <div className="text-danger"><small>{invalid.adverseProvider}</small></div>}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="card-footer">
        <div className="row">
          <div className="col-sm-4 pr-2">
            <button
              onClick={this.props.backStep}
              type="button" className="btn btn-outline-primary btn-block">Back</button>
          </div>
          <div className="col-sm-4 pl-2">
            <button
              onClick={this.handleValidate}
              type="button" className="btn btn-primary btn-block">Next</button>
          </div>
        </div>
      </div>
    </div >
  }
}

const mapStateToProps = state => {
  return {
    clientServices: state.client.services
  }
}

export default connect(mapStateToProps)(VaccineDetails);